var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "environment__switch" },
      [
        _c(
          "span",
          {
            staticClass: "environment__switch-label is-size-7",
            class: {
              "environment__switch-label--success has-text-weight-bold": !_vm.isTest
            }
          },
          [_vm._v("\n        Live\n    ")]
        ),
        _vm._v(" "),
        _c("sc-env-switch", {
          attrs: { color: _vm.isTest ? "red" : "green" },
          model: {
            value: _vm.isTest,
            callback: function($$v) {
              _vm.isTest = $$v
            },
            expression: "isTest"
          }
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "environment__switch-label is-size-7",
            class: {
              "environment__switch-label--danger has-text-weight-bold":
                _vm.isTest
            }
          },
          [_vm._v("\n        Test\n    ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7aceeb6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7aceeb6c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/sc-environment/ScEnvironment.vue
// module id = null
// module chunks = 